import { AnyAction } from 'redux';

import { createAction, Type } from './utils';

export const setAuthentication = (payload: any): AnyAction => createAction(Type.SET_AUTHENTICATION, payload);
